import { render, staticRenderFns } from "./TogglePanelComponent.vue?vue&type=template&id=04a6f43f&scoped=true&"
import script from "./TogglePanelComponent.vue?vue&type=script&lang=js&"
export * from "./TogglePanelComponent.vue?vue&type=script&lang=js&"
import style0 from "./TogglePanelComponent.vue?vue&type=style&index=0&id=04a6f43f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6f43f",
  null
  
)

export default component.exports